export default function initializeFacebook() {
  const fbData = document.querySelector("[data-fb-app-id]")?.dataset
  const appId = fbData?.fbAppId
  if (!appId) return

  window.fbAsyncInit = function () {
    FB.init({
      appId,
      version: fbData?.fbVersion || "v21.0",
      cookie: true,
    })
  }

  window.App.loadScriptAsync("//connect.facebook.net/en_US/sdk.js", "facebook-jssdk", { crossorigin: "anonymous" }, 1)
    .catch(() => {
      window.App.env === "development" && console.error("Failed to load Facebook SDK. Fallback to direct anchor link")
    })
}
